module.exports = __webpack_public_path__ + "static/media/phone-laptop.d1235c70.svg";